var map = {
	"./codes/address-doctor.codes.json": 59450,
	"./codes/address-field-names.json": 66110,
	"./codes/article-affiliations-editor.codes.json": 36558,
	"./codes/article-affiliations-help-widget.codes.json": 95363,
	"./codes/article.codes.json": 88244,
	"./codes/assign-article_by-id.codes.json": 28750,
	"./codes/assign-article_by-journal.codes.json": 54506,
	"./codes/buttons.codes.json": 95735,
	"./codes/combobox.codes.json": 8941,
	"./codes/config/config.mock.json": 61045,
	"./codes/config/config.perf.json": 13616,
	"./codes/config/config.ppd.json": 96725,
	"./codes/config/config.prod.json": 31002,
	"./codes/config/config.qa.json": 31165,
	"./codes/config/config.sit.json": 73061,
	"./codes/config/config.uat.json": 99755,
	"./codes/dashboard/dashboard.json": 88733,
	"./codes/dashboard/left_side.json": 41712,
	"./codes/dashboard/orders.json": 43690,
	"./codes/dashboard/panel_actions.json": 12019,
	"./codes/dashboard/panel_status.json": 31126,
	"./codes/dashboard/widgets.json": 62884,
	"./codes/deprecated-codes.json": 74676,
	"./codes/dialog.codes.json": 86474,
	"./codes/discount-widget.codes.json": 98152,
	"./codes/email-alerts.json": 37662,
	"./codes/error.codes.json": 29888,
	"./codes/field.names.json": 18872,
	"./codes/funder.codes.json": 79946,
	"./codes/impact-widget.codes.json": 89747,
	"./codes/institution_picker.codes.json": 77739,
	"./codes/legacy/common.codes.json": 1063,
	"./codes/legacy/login.codes.json": 12171,
	"./codes/legacy/profile-account.codes.json": 41697,
	"./codes/legacy/recover-password.codes.json": 49976,
	"./codes/legacy/registration.codes.json": 56271,
	"./codes/legacy/reset-password.codes.json": 34993,
	"./codes/license-signing.codes.json": 59907,
	"./codes/license-submission.codes.json": 11664,
	"./codes/license.codes.json": 97325,
	"./codes/license__types.json": 21768,
	"./codes/license__types.selection-grid-config.codes.json": 67020,
	"./codes/order-errors.codes.json": 61478,
	"./codes/order-panels.codes.json": 70994,
	"./codes/panel.codes.json": 35708,
	"./codes/postal-code-formats.json": 10556,
	"./codes/prompt/prompt.json": 63435,
	"./codes/search.codes.json": 79018,
	"./codes/service-names.json": 85884,
	"./codes/state-mandatory-countries.json": 96110,
	"./codes/support-widget.codes.json": 79564,
	"./codes/tooltip/tooltip.json": 86565,
	"./codes/upload-license.codes.json": 809,
	"./codes/vat-tax.codes.json": 68113,
	"./html/MULTI_AUTHORS_EXAMPLE.html": 12391,
	"./html/MULTI_AUTHOR_NO.html": 65197,
	"./html/MULTI_AUTHOR_YES.html": 89159,
	"./html/SINGLE_AUTHOR_NO.html": 45614,
	"./html/SINGLE_AUTHOR_YES.html": 64874,
	"./html/address-doctor__suggestions.html": 27343,
	"./html/advanced-search__no-results.html": 47559,
	"./html/advanced-search__no-results_for-author.html": 91219,
	"./html/alipay-help-text.html": 35152,
	"./html/alipay-info-text.html": 52769,
	"./html/assign-article__1628870.html": 1192,
	"./html/assign-article__ADMIN_FLOW_CORR_AUTHOR_CHANGE.html": 82364,
	"./html/assign-article__ADMIN_FLOW_NO_ARTICLE.html": 10679,
	"./html/assign-article__ADMIN_FLOW_NO_EMAIL_MATCH.html": 63707,
	"./html/assign-article__ARTICLE_ASSIGNED.html": 25417,
	"./html/assign-article__MANUAL_ARTICLE_ASSIGNMENT_REQUESTED.html": 50274,
	"./html/assign-article__MANUAL_ARTICLE_ASSIGNMENT_REQUESTED_DOUBLE.html": 46460,
	"./html/banner-message-all-spa.html": 7563,
	"./html/banner-message-dashboard.html": 29963,
	"./html/banner-message-login.html": 84490,
	"./html/banner-message-online-open.html": 48481,
	"./html/banner-message-openaccess.html": 65321,
	"./html/banner-message-orders.html": 47838,
	"./html/banner-message-profile.html": 59986,
	"./html/banner-message-register.html": 90542,
	"./html/billing-address-text.html": 22580,
	"./html/dashboard-promo-bottom.html": 58456,
	"./html/dashboard-promo.html": 30070,
	"./html/dashboard__promote.html": 50948,
	"./html/dashboard__search.html": 8762,
	"./html/discount-service-unavailable-error.html": 50411,
	"./html/footer.html": 57113,
	"./html/funder-editor-inline.html": 41534,
	"./html/get_started.html": 72414,
	"./html/help-widget-AUTHOR.html": 85071,
	"./html/help-widget-CORRESPONDING_AUTHOR.html": 79760,
	"./html/help-widget-RESPONSIBLE_CORRESPONDING_AUTHOR.html": 91501,
	"./html/help-widget-affiliations.html": 22748,
	"./html/impact-widget__not-mostCited.html": 49431,
	"./html/impact-widget__not-mostRecent.html": 54519,
	"./html/licence__change-funders.html": 43445,
	"./html/license__CC-BY-NC-ND.html": 36624,
	"./html/license__CC-BY-NC-SA.html": 63262,
	"./html/license__CC-BY-NC.html": 82353,
	"./html/license__CC-BY-ND.html": 32336,
	"./html/license__CC-BY-SA.html": 58974,
	"./html/license__CC-BY.html": 16305,
	"./html/license__Contributing_Authors.html": 44146,
	"./html/license__Subscription.html": 96020,
	"./html/license__agreement__CC-BY-NC-ND.html": 62554,
	"./html/license__agreement__CC-BY-NC-SA.html": 89536,
	"./html/license__agreement__CC-BY-NC.html": 59275,
	"./html/license__agreement__CC-BY-ND.html": 88358,
	"./html/license__agreement__CC-BY-SA.html": 89372,
	"./html/license__agreement__CC-BY.html": 8983,
	"./html/license__agreement__CTA.html": 2501,
	"./html/license__agreement__ELA.html": 43531,
	"./html/license__agreement__Subscription.html": 36022,
	"./html/license__agreement__default.html": 53734,
	"./html/license__agreement_base.html": 35429,
	"./html/license__change-funders-with-funder-name.html": 72043,
	"./html/license__change-funders.html": 56997,
	"./html/license__confirmation-OOOrder.html": 42987,
	"./html/license__confirmation-all-authors.html": 75487,
	"./html/license__confirmation-download.html": 33433,
	"./html/license__confirmation-electronicLicense.html": 95720,
	"./html/license__confirmation-license-correct.html": 87649,
	"./html/license__confirmation-license-incorrect.html": 26724,
	"./html/license__confirmation-main.html": 41296,
	"./html/license__confirmation-not-all-authors.html": 45995,
	"./html/license__confirmation-upload.html": 14996,
	"./html/license__funding-help.html": 33046,
	"./html/license__initiate__cancel.html": 42958,
	"./html/license__initiate__funding-eligible.html": 75701,
	"./html/menu__authors.html": 97679,
	"./html/menu__editors.html": 32297,
	"./html/menu__help.html": 11800,
	"./html/menu__reviewers.html": 43191,
	"./html/menu_resources__authors.html": 4125,
	"./html/menu_resources__other.html": 1787,
	"./html/menu_resources__reviewers.html": 81021,
	"./html/missing_article.html": 14841,
	"./html/my_profile_widget__completed.html": 8766,
	"./html/order__affiliation.html": 20882,
	"./html/order__cancel.html": 35960,
	"./html/order__confirmation-OAOrder.html": 15706,
	"./html/order__confirmation-OOOrder.html": 73900,
	"./html/order__funders.html": 42049,
	"./html/order__license-required-funders.html": 11509,
	"./html/order__panel_contact__select_addresses.html": 89128,
	"./html/order__recommend-institution.html": 54069,
	"./html/order__restricted-confirmation.html": 78181,
	"./html/order__restricted-funders.html": 68755,
	"./html/order_oa_initialte__saved.html": 62126,
	"./html/order_oa_initiate__cancel.html": 74345,
	"./html/order_oa_initiate__change_profile.html": 66549,
	"./html/order_oa_initiate__saved.html": 16836,
	"./html/order_oa_review__cancel.html": 31726,
	"./html/order_oa_review__confirm.html": 7202,
	"./html/order_oo__confirm_info.html": 26386,
	"./html/order_oo__currency_info_message.html": 14251,
	"./html/order_oo__eligible_info.html": 35797,
	"./html/order_oo__payment_info_message.html": 70312,
	"./html/order_oo_discounted__currency_info_message.html": 82090,
	"./html/order_oo_initialte__saved.html": 39900,
	"./html/order_oo_initiate__cancel.html": 67851,
	"./html/order_oo_initiate__change_profile.html": 35471,
	"./html/order_oo_initiate__changed-country.html": 8558,
	"./html/order_oo_initiate__funding-eligible.html": 91880,
	"./html/order_oo_initiate__saved.html": 69350,
	"./html/order_oo_review__cancel.html": 49312,
	"./html/order_oo_review__confirm.html": 14800,
	"./html/order_oo_review__saved.html": 52651,
	"./html/panel-actions__buttons_reject-article.html": 74276,
	"./html/panel_actions__buttons__cancel_order.html": 45400,
	"./html/profile__manage_preferences.html": 21857,
	"./html/prompt__common.html": 80683,
	"./html/prompt__copyrightOwnership.html": 33668,
	"./html/prompt__country.html": 95902,
	"./html/prompt__funder.html": 16238,
	"./html/prompt__funderEditor.html": 96711,
	"./html/prompt__funderedit.html": 88314,
	"./html/prompt__licenseUpload.html": 95882,
	"./html/prompt__openAccessOption.html": 77977,
	"./html/prompt__orcid.html": 14007,
	"./html/prompt__pubcharge.html": 30507,
	"./html/register_help_section.html": 50893,
	"./html/undefined.html": 62332,
	"./html/vat-tax__europe.html": 27375,
	"./html/vat-tax__europe_exemption.html": 18335,
	"./html/vat-tax__notUsCanada.html": 86882,
	"./html/vat-tax__uscanada.html": 25019,
	"./html/view_full_article.html": 21586,
	"./media/CC-BY-NC-ND.png": 51572,
	"./media/CC-BY-NC-SA.png": 98438,
	"./media/CC-BY-NC.png": 27659,
	"./media/CC-BY-ND.png": 81748,
	"./media/CC-BY-SA.png": 44966,
	"./media/CC-BY.png": 29144,
	"./media/Subscription.png": 11592,
	"./media/img.png": 37966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35170;